import { render, staticRenderFns } from "./BaseFooterPriceGrade.vue?vue&type=template&id=0f96e81c&scoped=true&"
import script from "./BaseFooterPriceGrade.vue?vue&type=script&lang=js&"
export * from "./BaseFooterPriceGrade.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterPriceGrade.vue?vue&type=style&index=0&id=0f96e81c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96e81c",
  null
  
)

export default component.exports